import { Reveal } from "./Reveal";

export const MeetShellie = () => (
  <section data-testid="meet-shellie-section" className="py-16 sm:py-24 lg:py-32">
    <div className="max-w-6xl mx-auto px-4 sm:px-8 lg:px-16 grid grid-cols-1 md:grid-cols-12 gap-10 lg:gap-16 items-center">
      <div className="md:col-span-5 relative">
        <Reveal>
          <div className="rounded-2xl overflow-hidden border border-[#EFE6D8] shadow-[0_24px_60px_-24px_rgba(36,30,26,0.35)]">
            <img
              src="/photos/photo2.jpg"
              alt="Shellie Davis with Helena in the carrier"
              className="w-full h-full object-cover aspect-[4/5]"
              loading="lazy"
            />
          </div>
          <p className="font-script text-3xl text-[#8C4A32] mt-4 -rotate-2 origin-left">Shellie Davis</p>
        </Reveal>
      </div>
      <div className="md:col-span-7">
        <Reveal delay={0.1}>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#8C4A32] mb-4">Meet Shellie</p>
          <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] text-[#241E1A] font-medium">
            A language expert who still heard her mother's voice come out.
          </h2>
          <div className="mt-6 space-y-5 text-base sm:text-lg leading-relaxed text-[#5C524A]">
            <p>
              I'm Shellie Davis, M.S., SLP — a parent coach and girl mom. I have a master's degree
              in language development and have spent 10 years working with mothers and children.
              Over and over, I've seen that the words a child hears every day become how she sees
              herself, money, and what she deserves.
            </p>
            <p>
              I've also been the mom in the Target aisle who heard her mother's voice come out —
              even as a language expert. Once, in my bedroom, trying to get two-year-old Helena to
              listen, I randomly started counting down… and caught myself shaking my head,
              recognizing that was definitely from my childhood and NOT what I wanted for my
              relationship with my kid.
            </p>
            <p>
              That was one of many moments that led me to build this framework for mothers of
              little ones.
            </p>
            <p className="text-sm font-semibold uppercase tracking-[0.15em] text-[#8A7E74]">
              LLA is parent coaching, not therapy.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
